import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_SMART_FILTERS,
} from './constants';
import {
  getSmartFiltersTranslationKeys,
} from './translations';

export class SmartFiltersModule extends AppModule {
  addRoutes(): void {}

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_SMART_FILTERS, getSmartFiltersTranslationKeys);
  }
}
